import { useTranslation } from '../hooks/useTranslation'

interface TableToolbarProps {
  searchValue: string
  onSearchChange: (q: string) => void
}

export function TableToolbar({ searchValue, onSearchChange }: TableToolbarProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center gap-3 px-4 py-3 border-b border-border-subtle">
      {/* Search */}
      <div className="relative">
        <svg
          className="absolute left-[10px] top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-text-tertiary pointer-events-none"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
          />
        </svg>
        <input
          type="text"
          placeholder={t('toolbar.search')}
          className="w-[240px] h-8 pl-8 pr-3 text-[13px] bg-bg-input border border-border-subtle rounded-md text-text-primary placeholder-text-tertiary focus:outline-none focus:border-primary-red transition-colors font-sans"
          value={searchValue}
          onChange={e => onSearchChange(e.target.value)}
        />
      </div>

      {/* View Toggle */}
      <div className="ml-auto flex gap-[2px] bg-bg-input rounded-md p-[2px]">
        <button
          type="button"
          className="px-3 py-1.5 min-h-[32px] text-[12px] font-sans rounded-sm transition-colors bg-primary-red/10 text-primary-red"
        >
          {t('toolbar.table_view')}
        </button>
        <button
          type="button"
          className="px-3 py-1.5 min-h-[32px] text-[12px] font-sans rounded-sm transition-colors text-text-tertiary cursor-not-allowed opacity-50"
          title={t('toolbar.coming_soon')}
          disabled
        >
          {t('toolbar.cards_view')}
        </button>
      </div>
    </div>
  )
}
